import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import Config from '../../commons/config/Config.js'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import Security from '../../commons/security/Security.js'
import {
	Collapse, Grid, Box, TextField, MenuItem,
	Table, TableContainer, TableHead, TableBody, TableRow, TablePagination,
	CircularProgress, FormControlLabel, Checkbox,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import UpIcon from '@material-ui/icons/KeyboardArrowUp'
import { StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles.js'

var ESTADO_STATUS = {
	PROCESANDO: 'processing',
	COMPLETADA: 'completed',
	RECHAZADA:  'rejected',
	FALLIDA:    'error',
	INCOMPLETA: 'incomplete',
}

var ESTADOS = [
	{ value: '',           label: 'Todos'       },
	{ value: 'COMPLETADA', label: 'Completada'  },
	{ value: 'PROCESANDO', label: 'Procesando'  },
	{ value: 'FALLIDA',    label: 'Fallida'     },
	{ value: 'RECHAZADA',  label: 'Rechazada'   },
	{ value: 'INCOMPLETA', label: 'Incompleta'  },
]

var BADGE = {
	completed:  { cls: 'badge badge-success',   label: 'Completada'  },
	processing: { cls: 'badge badge-warning',   label: 'Procesando'  },
	error:      { cls: 'badge badge-danger',    label: 'Fallida'     },
	rejected:   { cls: 'badge badge-secondary', label: 'Rechazada'   },
	incomplete: { cls: 'badge badge-light',     label: 'Incompleta'  },
}

class EricInspeccionesGrid extends Component {
	constructor(props) {
		super(props)
		this._mounted = false
		this.state = {
			redirectTo:          null,
			loading:             true,
			data:                [],
			total:               0,
			kpis:                null,
			page:                1,
			perPage:             20,
			dropdownActive:      false,
			filtroEstado:        '',
			filtroPatente:       '',
			filtroDiscPatente:   false,
			filtroDiscVin:       false,
			filtroDiscOdometro:  false,
			filtroDiscBranding:  false,
			discDropdownOpen:    false,
			filtroFechaDesde:    '',
			filtroFechaHasta:    '',
			patenteInput:        '',
			reasignandoId:       null,
			movilIdInput:        '',
			reasignandoLoading:  false,
			reasignError:        '',
			abandonandoId:       null,
			columna_extra:       null,
			filtroExtra:         '',
			extraInput:          '',
		}
		this.handleFiltroEstado        = this.handleFiltroEstado.bind(this)
		this.handleFiltroPatente       = this.handleFiltroPatente.bind(this)
		this.handlePatenteKeyDown      = this.handlePatenteKeyDown.bind(this)
		this.handleFiltroDisc          = this.handleFiltroDisc.bind(this)
		this.handleDiscClickOutside    = this.handleDiscClickOutside.bind(this)
		this.handleFiltroFechaDesde    = this.handleFiltroFechaDesde.bind(this)
		this.handleFiltroFechaHasta    = this.handleFiltroFechaHasta.bind(this)
		this.handleFiltroExtra         = this.handleFiltroExtra.bind(this)
		this.handleExtraKeyDown        = this.handleExtraKeyDown.bind(this)
		this.irAPagina                 = this.irAPagina.bind(this)
		this.iniciarReasignacion       = this.iniciarReasignacion.bind(this)
		this.cancelarReasignacion      = this.cancelarReasignacion.bind(this)
		this.confirmarReasignacion     = this.confirmarReasignacion.bind(this)
		this.marcarIncompleta          = this.marcarIncompleta.bind(this)
	}

	componentWillMount() {
		this._mounted = true
		if (!Security.hasPermission('ERIC_INSPECTOR_LISTAR')) {
			this.setState({ redirectTo: '/error' })
			return
		}
		this.cargar(1)
		document.addEventListener('mousedown', this.handleDiscClickOutside)
	}

	componentWillUnmount() {
		this._mounted = false
		document.removeEventListener('mousedown', this.handleDiscClickOutside)
	}

	handleDiscClickOutside(e) {
		if (this._discDropdownRef && !this._discDropdownRef.contains(e.target)) {
			this.setState({ discDropdownOpen: false })
		}
	}

	buildQS(page, estado, patente, discPatente, discVin, discOdometro, discBranding, fechaDesde, fechaHasta, extraValor) {
		var params = ['page=' + page, 'per_page=' + this.state.perPage]
		if (estado)       params.push('estado='      + encodeURIComponent(estado))
		if (patente)      params.push('patente='     + encodeURIComponent(patente))
		if (discPatente)  params.push('disc_patente=1')
		if (discVin)      params.push('disc_vin=1')
		if (discOdometro) params.push('disc_odometro=1')
		if (discBranding) params.push('disc_branding=1')
		if (fechaDesde)   params.push('fecha_desde=' + encodeURIComponent(fechaDesde))
		if (fechaHasta)   params.push('fecha_hasta=' + encodeURIComponent(fechaHasta))
		if (extraValor)   params.push('extra_valor=' + encodeURIComponent(extraValor))
		return params.join('&')
	}

	cargar(page) {
		if (!this._mounted) return
		this.setState({ loading: true })
		var component = this
		var s = this.state
		var qs = this.buildQS(page, s.filtroEstado, s.filtroPatente, s.filtroDiscPatente, s.filtroDiscVin, s.filtroDiscOdometro, s.filtroDiscBranding, s.filtroFechaDesde, s.filtroFechaHasta, s.filtroExtra)

		fetch(Config.get('apiUrlBase') + '/v1/inspections?' + qs, {
			headers: { 'Authorization-Token': localStorage.getItem('token') }
		})
		.then(function(response) {
			if (!component._mounted) return null
			return response.json()
		})
		.then(function(data) {
			if (!component._mounted || !data) return
			component.setState({
				loading:      false,
				data:         data.data         || [],
				total:        data.total        || 0,
				kpis:         data.kpis         || null,
				columna_extra: data.columna_extra || null,
				page:         page,
			})
		})
		.catch(function() {
			if (component._mounted) component.setState({ loading: false })
		})
	}

	handleFiltroEstado(e) {
		this.setState({ filtroEstado: e.target.value }, function() { this.cargar(1) })
	}

	handleFiltroPatente(e) {
		this.setState({ patenteInput: e.target.value })
	}

	handlePatenteKeyDown(e) {
		if (e.key === 'Enter') {
			this.setState({ filtroPatente: this.state.patenteInput }, function() { this.cargar(1) })
		}
	}

	handleFiltroDisc(field, checked) {
		this.setState({ [field]: checked }, function() { this.cargar(1) })
	}

	handleFiltroFechaDesde(e) {
		this.setState({ filtroFechaDesde: e.target.value }, function() { this.cargar(1) })
	}

	handleFiltroFechaHasta(e) {
		this.setState({ filtroFechaHasta: e.target.value }, function() { this.cargar(1) })
	}

	handleFiltroExtra(e) {
		this.setState({ extraInput: e.target.value })
	}

	handleExtraKeyDown(e) {
		if (e.key === 'Enter') {
			this.setState({ filtroExtra: this.state.extraInput }, function() { this.cargar(1) })
		}
	}

	irAPagina(page) {
		this.cargar(page)
	}

	iniciarReasignacion(id) {
		this.setState({ reasignandoId: id, movilIdInput: '', reasignError: '' })
	}

	cancelarReasignacion() {
		this.setState({ reasignandoId: null, movilIdInput: '', reasignError: '' })
	}

	confirmarReasignacion(e) {
		e.preventDefault()
		var component = this
		var id      = this.state.reasignandoId
		var movilId = parseInt(this.state.movilIdInput, 10)
		if (!movilId || movilId <= 0) {
			this.setState({ reasignError: 'Ingresá un ID de vehículo válido.' })
			return
		}
		this.setState({ reasignandoLoading: true, reasignError: '' })
		fetch(Config.get('apiUrlBase') + '/v1/inspections/' + id + '/reassign', {
			method: 'POST',
			headers: {
				'Authorization-Token': localStorage.getItem('token'),
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ movil_id: movilId }),
		})
		.then(function(response) {
			if (!component._mounted) return null
			return response.json().then(function(body) {
				return { status: response.status, body: body }
			})
		})
		.then(function(res) {
			if (!component._mounted || !res) return
			if (res.status === 200) {
				component.setState({ reasignandoId: null, movilIdInput: '', reasignError: '', reasignandoLoading: false })
				component.cargar(component.state.page)
			} else {
				var msg = res.body && res.body.error ? res.body.error : 'No se pudo reasignar la inspección.'
				component.setState({ reasignError: msg, reasignandoLoading: false })
			}
		})
		.catch(function() {
			if (component._mounted) component.setState({ reasignError: 'Error de conexión.', reasignandoLoading: false })
		})
	}

	marcarIncompleta(id) {
		if (!this._mounted) return
		var component = this
		this.setState({ abandonandoId: id })
		fetch(Config.get('apiUrlBase') + '/v1/inspections/' + id + '/abandon', {
			method: 'PATCH',
			headers: { 'Authorization-Token': localStorage.getItem('token') },
		})
		.then(function(response) {
			if (!component._mounted) return
			if (response.ok) {
				component.cargar(component.state.page)
			}
			component.setState({ abandonandoId: null })
		})
		.catch(function() {
			if (component._mounted) component.setState({ abandonandoId: null })
		})
	}

	renderKpis() {
		var kpis = this.state.kpis
		if (!kpis) return null

		var cards = [
			{
				label: 'Total inspecciones',
				value: kpis.total != null ? kpis.total : 0,
				icon:  'fa fa-camera',
				color: '#607d8b',
			},
			{
				label: 'Con daños detectados',
				value: kpis.con_danios != null ? kpis.con_danios : 0,
				icon:  'fa fa-warning',
				color: '#e55353',
			},
			{
				label: 'Pendientes de revisión',
				value: kpis.procesando != null ? kpis.procesando : 0,
				icon:  'fa fa-clock-o',
				color: '#f39c12',
			},
		]

		return (
			<div className="row mb-2">
				{cards.map(function(card) {
					return (
						<div key={card.label} className="col-md-4">
							<div className="card pull-up">
								<div className="card-content" style={{ borderRadius: '.45rem' }}>
									<div className="card-body" style={{ padding: '15px' }}>
										<div className="text-right">
											<h6 className="text-muted text-bold-500">{card.label}</h6>
										</div>
										<div className="media d-flex">
											<div className="align-self-center mr-3">
												<i className={card.icon} style={{ fontSize: '2.5rem', color: card.color, opacity: 0.8 }}></i>
											</div>
											<div className="media-body text-right">
												<h3 className="text-bold-600" style={{ color: card.color }}>{card.value}</h3>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					)
				})}
			</div>
		)
	}

	renderEstadoBadge(status) {
		var entry = BADGE[status]
		if (!entry) return <span className="badge badge-light">{status}</span>
		return <span className={entry.cls}>{entry.label}</span>
	}

	renderReasignModal() {
		if (this.state.reasignandoId === null) return null
		return (
			<div
				style={{
					position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
					backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 1050,
					display: 'flex', alignItems: 'center', justifyContent: 'center',
				}}
				onClick={this.cancelarReasignacion}
			>
				<div
					className="card"
					style={{ width: '360px', margin: 0 }}
					onClick={function(e) { e.stopPropagation() }}
				>
					<div className="card-header py-2 px-3">
						<strong>Reasignar inspección #{this.state.reasignandoId}</strong>
					</div>
					<form onSubmit={this.confirmarReasignacion}>
						<div className="card-body py-3 px-3">
							<p className="text-muted mb-2" style={{ fontSize: '0.85rem' }}>
								Ingresá el ID del vehículo correcto para vincular esta inspección.
							</p>
							<div className="form-group mb-2">
								<label style={{ fontSize: '0.8rem' }}>ID de vehículo</label>
								<input
									type="number"
									min="1"
									className="form-control form-control-sm"
									placeholder="Ej: 42"
									value={this.state.movilIdInput}
									onChange={function(e) { this.setState({ movilIdInput: e.target.value, reasignError: '' }) }.bind(this)}
									autoFocus
								/>
							</div>
							{this.state.reasignError && (
								<div className="alert alert-danger py-1 px-2 mb-0" style={{ fontSize: '0.8rem' }}>
									{this.state.reasignError}
								</div>
							)}
						</div>
						<div className="card-footer py-2 px-3 d-flex justify-content-end" style={{ gap: '8px' }}>
							<button
								type="button"
								className="btn btn-sm btn-secondary"
								onClick={this.cancelarReasignacion}
								disabled={this.state.reasignandoLoading}
							>Cancelar</button>
							<button
								type="submit"
								className="btn btn-sm btn-primary"
								disabled={this.state.reasignandoLoading}
							>
								{this.state.reasignandoLoading ? 'Guardando...' : 'Confirmar'}
							</button>
						</div>
					</form>
				</div>
			</div>
		)
	}

	render() {
		if (this.state.redirectTo) return <Redirect to={this.state.redirectTo} />

		var component   = this
		var matchUrl    = this.props.match ? this.props.match.url : '/eric/inspector'
		var hasFilters  = !!(
			this.state.filtroEstado ||
			this.state.filtroPatente ||
			this.state.filtroDiscPatente ||
			this.state.filtroDiscVin ||
			this.state.filtroDiscOdometro ||
			this.state.filtroFechaDesde ||
			this.state.filtroFechaHasta ||
			this.state.filtroExtra
		)
		var columnaExtra              = this.state.columna_extra
		var brandingHabilitado        = ConfigBusiness.get('eric.inspecciones.capacidades.brand_compliance') === 'true'
		var colSpan                   = 10 + (columnaExtra ? 1 : 0) + (brandingHabilitado ? 1 : 0)

		return (
			<div className="content-body">
				{this.renderReasignModal()}

				<div className="content-header row">
					<div className="content-header-left col-12 mb-2">
						<h3 className="content-header-title">
							<i className="fa fa-camera mr-1"></i>
							Eric IA — Detección de Daños
						</h3>
					</div>
				</div>

				{this.renderKpis()}

				<div className="card">
					<div className="card-content collpase show">
						<div className="card-body card-dashboard">

							<div className="container-fluid mb-1">
								<div className="row dt-icons">
									<div className="col">
										<StyledTooltip title={this.state.dropdownActive ? 'Ocultar filtros' : 'Mostrar filtros'} placement="right">
											<div
												className="btn btn-grey-blue box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
												style={{ height: 52 }}
												onClick={() => this.setState({ dropdownActive: !this.state.dropdownActive })}
											>
												{this.state.dropdownActive ? <UpIcon /> : <ExpandMoreIcon />}
											</div>
										</StyledTooltip>
									</div>
									<div className="col">
										{hasFilters && (
											<div className="btn-dt-main round-icon">
												<div
													className="text-center"
													style={{
														height: '25px',
														borderRadius: '3px',
														display: 'flex',
														justifyContent: 'center',
														alignItems: 'center',
														paddingLeft: '8px',
														backgroundColor: '#5AAC43',
														color: 'white',
													}}
												>
													<div style={{ width: '100%', fontSize: '12px', fontWeight: '500' }}>
														{this.state.total} resultado{this.state.total !== 1 ? 's' : ''} de búsqueda
													</div>
													<div className="resultados-busqueda-notif">
														<i
															className="las la-times la-xs cursor-pointer"
															onClick={() => this.setState({
																filtroEstado: '', filtroPatente: '',
																filtroDiscPatente: false, filtroDiscVin: false, filtroDiscOdometro: false, filtroDiscBranding: false,
																discDropdownOpen: false,
																filtroFechaDesde: '', filtroFechaHasta: '', patenteInput: '',
																filtroExtra: '', extraInput: '',
															}, () => this.cargar(1))}
														></i>
													</div>
												</div>
											</div>
										)}
									</div>
								</div>
							</div>

							<Collapse in={this.state.dropdownActive} style={{ marginBottom: 20 }}>
								<Grid container item xs={12} spacing={3} className="filtros">
									<Grid component={Box} item xs={3}>
										<TextField
											select
											label="Estado"
											value={this.state.filtroEstado}
											onChange={this.handleFiltroEstado}
											className="col-12"
										>
											{ESTADOS.map(function(e) {
												return <MenuItem key={e.value} value={e.value}>{e.label}</MenuItem>
											})}
										</TextField>
									</Grid>
									{columnaExtra && (
										<Grid component={Box} item xs={3}>
											<TextField
												label={columnaExtra.label}
												value={this.state.extraInput}
												onChange={this.handleFiltroExtra}
												onKeyDown={this.handleExtraKeyDown}
												placeholder="Enter para buscar"
												className="col-12"
											/>
										</Grid>
									)}
									<Grid component={Box} item xs={3}>
										<TextField
											label="Patente"
											value={this.state.patenteInput}
											onChange={this.handleFiltroPatente}
											onKeyDown={this.handlePatenteKeyDown}
											placeholder="Enter para buscar"
											className="col-12"
										/>
									</Grid>
									<Grid component={Box} item xs={3}>
										<TextField
											label="Desde"
											type="date"
											value={this.state.filtroFechaDesde}
											onChange={this.handleFiltroFechaDesde}
											className="col-12"
											InputLabelProps={{ shrink: true }}
										/>
									</Grid>
									<Grid component={Box} item xs={3}>
										<TextField
											label="Hasta"
											type="date"
											value={this.state.filtroFechaHasta}
											onChange={this.handleFiltroFechaHasta}
											className="col-12"
											InputLabelProps={{ shrink: true }}
										/>
									</Grid>
									<Grid component={Box} item xs={3}>
										<div style={{ position: 'relative' }} ref={function(el) { this._discDropdownRef = el }.bind(this)}>
											<TextField
												label="Discrepancia"
												value={
													[
														this.state.filtroDiscPatente  ? 'Patente'   : null,
														this.state.filtroDiscVin      ? 'VIN'       : null,
														this.state.filtroDiscOdometro ? 'Odómetro'  : null,
														this.state.filtroDiscBranding ? 'Branding'  : null,
													].filter(Boolean).join(', ') || 'Sin filtro'
												}
												inputProps={{ readOnly: true, style: { cursor: 'pointer' } }}
												className="col-12"
												onClick={() => this.setState(function(s) { return { discDropdownOpen: !s.discDropdownOpen } })}
											/>
											{this.state.discDropdownOpen && (
												<div style={{
													position: 'absolute', zIndex: 1300, background: '#fff',
													border: '1px solid #ccc', borderRadius: 4, padding: '4px 8px',
													minWidth: '160px', top: '100%', left: 0, boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
												}}>
													{[
														{ field: 'filtroDiscPatente',   label: 'Patente'  },
														{ field: 'filtroDiscVin',       label: 'VIN'      },
														{ field: 'filtroDiscOdometro',  label: 'Odómetro' },
													{ field: 'filtroDiscBranding',  label: 'Branding' },
													].map(function(opt) {
														return (
															<FormControlLabel
																key={opt.field}
																style={{ display: 'block', margin: 0 }}
																control={
																	<Checkbox
																		checked={!!this.state[opt.field]}
																		onChange={function(e) { this.handleFiltroDisc(opt.field, e.target.checked) }.bind(this)}
																		color="primary"
																		size="small"
																	/>
																}
																label={opt.label}
															/>
														)
													}.bind(this))}
												</div>
											)}
										</div>
									</Grid>
								</Grid>
							</Collapse>

							<TableContainer>
								<Table aria-label="inspecciones" className="table-hover">
									<TableHead>
										<TableRow>
											<StyledTableCell>#</StyledTableCell>
											<StyledTableCell>Estado</StyledTableCell>
											{columnaExtra && <StyledTableCell>{columnaExtra.label}</StyledTableCell>}
											<StyledTableCell>Patente</StyledTableCell>
											<StyledTableCell>Marca / Modelo</StyledTableCell>
											<StyledTableCell>VIN</StyledTableCell>
											<StyledTableCell>Odómetro</StyledTableCell>
											<StyledTableCell>Formulario</StyledTableCell>
											<StyledTableCell>Daños</StyledTableCell>
											{brandingHabilitado && <StyledTableCell>Branding</StyledTableCell>}
											<StyledTableCell>Fecha</StyledTableCell>
											<StyledTableCell></StyledTableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{this.state.loading ? (
											<TableRow>
												<StyledTableCell colSpan={colSpan} align="center" style={{ padding: '32px' }}>
													<CircularProgress />
												</StyledTableCell>
											</TableRow>
										) : this.state.data.length === 0 ? (
											<TableRow>
												<StyledTableCell colSpan={colSpan} align="center">
													No se encontraron inspecciones.
												</StyledTableCell>
											</TableRow>
										) : (
											this.state.data.map(function(row) {
												var status         = ESTADO_STATUS[row.estado] || 'processing'
												var discrepancia   = !!row.flag_patente_discrepancia
												var movilPatente   = row.movil_patente   || null
												var inspecPatente  = row.vehiculo_patente || null
												var plateDiff      = movilPatente && inspecPatente &&
													movilPatente.toUpperCase() !== inspecPatente.toUpperCase()
												var timeoutMin     = parseInt(ConfigBusiness.get('eric.inspecciones.general.processingTimeoutMin'), 10) || 30
												var createdMs      = row.created_at ? new Date(row.created_at).getTime() : null
												var isStale        = status === 'processing' && createdMs !== null &&
													(Date.now() - createdMs) >= timeoutMin * 60 * 1000
												var canAbandon     = isStale && Security.hasPermission('ERIC_INSPECTOR_MODIFICAR')
												return (
													<TableRow key={row.id}>
														<StyledTableCell>{row.id}</StyledTableCell>
														<StyledTableCell>{component.renderEstadoBadge(status)}</StyledTableCell>
											{columnaExtra && <StyledTableCell>{row.movil_extra || '—'}</StyledTableCell>}
														<StyledTableCell>
															{movilPatente || inspecPatente || '—'}
															{plateDiff && (
																<StyledTooltip
																	title={'Inspección detectó: ' + inspecPatente}
																	placement="right"
																>
																	<span className="ml-1 badge badge-warning" style={{ cursor: 'default' }}>
																		<i className="fa fa-exclamation-triangle mr-1"></i>
																		{inspecPatente}
																	</span>
																</StyledTooltip>
															)}
															{!plateDiff && discrepancia && status !== 'processing' && (
																<span
																	className="ml-1 badge badge-warning"
																	title="Discrepancia de patente — el vehículo no coincide"
																>
																	<i className="fa fa-exclamation-triangle"></i>
																</span>
															)}
														</StyledTableCell>
														<StyledTableCell>
															{[row.vehiculo_marca, row.vehiculo_modelo].filter(Boolean).join(' ') || '—'}
														</StyledTableCell>
														<StyledTableCell>
															{row.vehiculo_vin ? (
																<span>
																	{row.vehiculo_vin}
																	{row.vin_problema && (
																		<StyledTooltip title="Discrepancia de VIN detectada" placement="right">
																			<span className="ml-1 badge badge-warning" style={{ cursor: 'default' }}>
																				<i className="fa fa-exclamation-triangle"></i>
																			</span>
																		</StyledTooltip>
																	)}
																</span>
															) : '—'}
														</StyledTableCell>
														<StyledTableCell>
															{row.vehiculo_km !== null && row.vehiculo_km !== undefined ? (
																<span>
																	{Math.round(row.vehiculo_km).toLocaleString()} km
																	{row.odometro_problema && (
																		<StyledTooltip title="Discrepancia de odómetro detectada" placement="right">
																			<span className="ml-1 badge badge-warning" style={{ cursor: 'default' }}>
																				<i className="fa fa-exclamation-triangle"></i>
																			</span>
																		</StyledTooltip>
																	)}
																</span>
															) : '—'}
														</StyledTableCell>
														<StyledTableCell>
														{row.formulario_id
															? <a href={'/formulario/' + row.formulario_id} target="_blank" rel="noopener noreferrer">{row.formulario_id}</a>
															: '—'
														}
													</StyledTableCell>
														<StyledTableCell>
															{row.danios_count > 0 ? (
																<span className="badge badge-danger">{row.danios_count}</span>
															) : status === 'processing' ? (
																<span className="text-muted" title="Pendiente — inspección en proceso">
																	<i className="fa fa-clock-o"></i>
																</span>
															) : (
																<span className="text-muted">0</span>
															)}
														</StyledTableCell>
														{brandingHabilitado && (
															<StyledTableCell>
																{row.conformidad_marca === null || row.conformidad_marca === undefined
																	? <span className="text-muted">—</span>
																	: row.conformidad_marca
																		? <span className="badge badge-success">OK</span>
																		: <span className="badge badge-danger">FAIL{row.branding_zonas_fallidas > 0 ? " · " + row.branding_zonas_fallidas : ""}</span>
																}
															</StyledTableCell>
														)}
														<StyledTableCell>
															{row.created_at ? row.created_at.substring(0, 10) : '—'}
														</StyledTableCell>
																									<StyledTableCell style={{ whiteSpace: 'nowrap' }}>
															<StyledTooltip title="Ver detalle" placement="left">
																<Link
																	to={matchUrl + '/' + row.id}
																	className="btn btn-sm btn-outline-primary"
																>
																	<i className="fa fa-eye"></i>
																</Link>
															</StyledTooltip>
															{canAbandon && (
																<StyledTooltip title="Marcar como incompleta" placement="left">
																	<button
																		className="btn btn-sm btn-outline-secondary ml-1"
																		disabled={component.state.abandonandoId === row.id}
																		onClick={function() { component.marcarIncompleta(row.id) }}
																	>
																		{component.state.abandonandoId === row.id
																			? <i className="fa fa-spinner fa-spin"></i>
																			: <i className="fa fa-times-circle"></i>
																		}
																	</button>
																</StyledTooltip>
															)}
														</StyledTableCell>
													</TableRow>
												)
											})
										)}
									</TableBody>
								</Table>
							</TableContainer>

							<TablePagination
								rowsPerPageOptions={[10, 20, 50]}
								component="div"
								count={this.state.total}
								rowsPerPage={this.state.perPage}
								page={this.state.page - 1}
								onPageChange={function(e, newPage) { component.irAPagina(newPage + 1) }}
								onRowsPerPageChange={function(e) {
									component.setState({ perPage: parseInt(e.target.value, 10), page: 1 }, function() {
										component.cargar(1)
									})
								}}
								labelRowsPerPage="Mostrar"
								labelDisplayedRows={function(obj) {
									return 'Mostrando ' + obj.from + ' a ' + obj.to + ' de ' + obj.count
								}}
							/>

						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default EricInspeccionesGrid
